import { render, staticRenderFns } from "./GetBackPD.vue?vue&type=template&id=357971fc&scoped=true&"
import script from "./GetBackPD.vue?vue&type=script&lang=js&"
export * from "./GetBackPD.vue?vue&type=script&lang=js&"
import style0 from "./GetBackPD.vue?vue&type=style&index=0&id=357971fc&prod&lang=scss&"
import style1 from "./GetBackPD.vue?vue&type=style&index=1&id=357971fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357971fc",
  null
  
)

export default component.exports